import { createAction, props } from '@ngrx/store';
import { RequestQueryPayload } from '@cureskin/api-client';

export const GetSupportQuestionFromStore = createAction('[Support Question] Get Support Question From Store',
  props<Partial<{ query: RequestQueryPayload<Table.SupportQuestion>; context: Record<string, unknown>; }>>());
export const SupportQuestionsFetchBegin = createAction('[Support Question] Support Question Fetch Begin',
  props<Partial<{ query: RequestQueryPayload<Table.SupportQuestion>; context: Record<string, unknown>; }>>());
export const SupportQuestionsFetchUpdate = createAction('[Support Question] Support Question Fetch Update',
  props<{ query: RequestQueryPayload<Table.SupportQuestion>; questions: Array<string>; error: string; }>());
